<template>
  <div>
    <div :class="id == 2 ? '' : 'mc_menu'" v-if="Periods">
      <span class="pull-left mc_menu_date" v-if="id != 2">{{
        newListTitle ? newListTitle : "Preprint"
      }}</span>
      <!-- <span class="rightfloat title_more visible-lg visible-md">
        <router-link :to="{path: type==0?'/OAList?IssueId=-1':'/PreprintList'}" v-if="isOA"></router-link>
      </span> -->
      <span class="rightfloat mc_menu_link">
        <a v-if="Periods.CoverGUID != null && type == 0" @click="downfil(1)"
          >Cover</a
        >
        <a v-if="Periods.BackCoverGUID != null && type == 0" @click="downfil(2)"
          >Back</a
        >
        <a v-if="Periods.TableConGUID != null && type == 0" @click="downfil(3)"
          >Contens</a
        >
        <!-- <router-link v-if="Periods.RSS" :to="'/image/'+rssUrl">RSS</router-link> -->
        <a @click="goRss" v-if="Periods.RSS && type == 0">RSS</a>
        <a @click="goRssa" v-if="type == 1">RSS</a>
      </span>
      <div class="clearfix"></div>
    </div>
    <!-- 文章列表 -->
    <gzhArticleList
      v-if="isgzh == true"
      :scroll="scroll"
      :List="List"
      :type="type"
      :isycb="isycb"
      :ischeckbox="ischeckbox"
      :count="count"
      :iscount="iscount"
      :isindex="isindex"
      :CloumnList="CloumnList"
      :isdataa="isdataa"
      :isdatab="isdatab"
    ></gzhArticleList>
    <ArticleList
      v-else
      :scroll="scroll"
      :List="List"
      :type="type"
      :isycb="isycb"
      :ischeckbox="ischeckbox"
      :count="count"
      :iscount="iscount"
      :isindex="isindex"
      :CloumnList="CloumnList"
      :isdataa="isdataa"
      :isdatab="isdatab"
    ></ArticleList>
  </div>
</template>
<script>
import ArticleList from "./ArticleList";
import gzhArticleList from "./gzhArticleList";
export default {
  data() {
    return {
      NewList: [],
      Lista: [],
      CoverGUID: false,
      BackCoverGUID: false,
      TableConGUID: false,
      Rss: false,
      isOA: true,
      rssUrl: "",
      cotype: "",
    };
  },
  props: [
    "type",
    "Periods",
    "List",
    "isycb",
    "newListTitle",
    "id",
    "ischeckbox",
    "count",
    "iscount",
    "isindex",
    "scroll",
    "CloumnList",
    "isdataa",
    "isdatab",
    "isgzh",
  ],
  watch: {},
  components: {
    ArticleList,
    gzhArticleList,
  },
  mounted() {
    if (this.$route.path == "/OAList") {
      this.isOA = false;
    } else {
      this.isOA = true;
    }
  },
  watch: {
    pdf(i) {
      var id = this.NewList[i].ArticleID;
      this._getXZCS(id);
    },
    todigest(e, id) {
      // this._getLLCS(id);
      this.getArticList(id);
    },
  },
  methods: {
    downfil(num) {
      let filename = "";
      let Suffix = "";
      if (num == 1) {
        this.FileGUID = this.Periods.CoverGUID;
        this.cotype = "Cover";
      } else if (num == 2) {
        this.FileGUID = this.Periods.BackCoverGUID;
        this.cotype = "BackCover";
      } else {
        this.FileGUID = this.Periods.TableConGUID;
        this.cotype = "TableCon";
      }
      let id = this.Periods.IssueID;

      let data = {
        Id: id,
        Type: this.cotype,
      };

      this.$store
        .dispatch("_OpenGUIDFile", {
          FileGUID: this.FileGUID,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1);
          } else {
            this.$error(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goRss() {
      this.$store.dispatch("_GetRss").then((res) => {
        this.rssUrl = res.data.Message;
        window.open(this.ImgUrl + this.rssUrl + "?");
      });
    },
    goRssa() {
      if (sessionStorage.getItem("SetItem")) {
        let SetItem = JSON.parse(sessionStorage.getItem("SetItem"));
        SetItem.map((item) => {
          if (item.SetItemID == 6018) {
            if (item.Item_Value == "是") {
              this.$store.dispatch("_GetscriptRssycb").then((res) => {
                this.rssUrl = res.data.Message;
                window.open(this.ImgUrl + this.rssUrl + "?");
              });
            } else {
              this.$store.dispatch("_GetRssycb").then((res) => {
                this.rssUrl = res.data.Message;
                window.open(this.ImgUrl + this.rssUrl + "?");
              });
            }
          }
        });
      } else {
        let params = [
          1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        ];
        this.$store
          .dispatch("_getSet", params)
          .then((res) => {
            this.SetItem = res.data.Data;
            sessionStorage.setItem("SetItem", JSON.stringify(res.data.Data));
            this.SetItem.map((item) => {
              if (item.SetItemID == 6018) {
                if (item.Item_Value == "是") {
                  this.$store.dispatch("_GetscriptRssycb").then((res) => {
                    this.rssUrl = res.data.Message;
                    window.open(this.ImgUrl + this.rssUrl + "?");
                  });
                } else {
                  this.$store.dispatch("_GetRssycb").then((res) => {
                    this.rssUrl = res.data.Message;
                    window.open(this.ImgUrl + this.rssUrl + "?");
                  });
                }
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    OpenGUIDFile(FileGUID) {
      this.$store
        .dispatch("_OpenGUIDFile", {
          FileGUID: FileGUID,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1);
          } else {
            this.$error(res.data.Message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
